import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { ScrollToTop } from '@/components/ScrollToTop';
import { PromoBanner } from '@/components/PromoBanner';
import { MobileBookBar } from '@/components/MobileBookBar';
import HomePage from '@/pages/Home';
import ServicesPage from '@/pages/Services';
import AboutPage from '@/pages/About';
import GalleryPage from '@/pages/Gallery';
import BookingPage from '@/pages/Booking';
import BookingSuccessPage from '@/pages/BookingSuccess';
import ContactPage from '@/pages/Contact';
import AdminPage from '@/pages/Admin';

const Shell = () => {
  const location = useLocation();
  return (
    <>
      <ScrollToTop pathname={location.pathname} />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/booking/success" element={<BookingSuccessPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      <Footer />
      <MobileBookBar />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: '#131A2D',
            color: '#ffffff',
            border: '1px solid rgba(201, 162, 74, 0.35)',
          },
        }}
      />
    </div>
  );
}

export default App;
